import { IconX } from '@tabler/icons-react'

import IconButton from 'shared/ui/IconButton'
import { addTestId } from 'shared/utils/tests'

import { useModalContext } from './ModalContext'

import styles from './ModalClose.module.scss'

type ModalCloseProps = {
  closeButtonLabel?: string
  ref?: React.RefObject<HTMLButtonElement | null>
}

export const ModalClose = ({
  closeButtonLabel = 'Zamknij okno dialogowe',
  ref
}: ModalCloseProps) => {
  const context = useModalContext()

  if (!context) {
    throw new Error('ModalClose must be used inside a <Modal> component.')
  }

  return (
    <IconButton
      className={styles.closeButton}
      size='medium'
      aria-label={closeButtonLabel}
      onClick={context.onClose}
      type='button'
      variant='transparent'
      {...addTestId('modal-close-icon')}
      ref={ref}
    >
      <IconX />
    </IconButton>
  )
}

export default ModalClose
